import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import RealEstateList from './RealEstateList';
import { useAuth0 } from '@auth0/auth0-react';

const RealEstatePage = () => {
    const [assets, setAssets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    const fetchAssets = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
             const token =  await getAccessTokenSilently({
            authorizationParams: {
                audience: process.env.REACT_APP_API_AUDIENCE,
                }
            });
            
            const response = await fetch(`${apiUrl}/api/assets`,{ 
                headers: {
                Authorization: `Bearer ${token}`,
              },
            });

            if (!response.ok) {
                throw new Error(`Real estate listings request failed with status ${response.status}`);
            }

            const data = await response.json();
            setAssets(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Error fetching assets:', error);
            setError('Could not load real estate listings. Please retry.');
        } finally {
            setLoading(false);
        }
    }, [apiUrl, getAccessTokenSilently]);

    useEffect(() => {
        fetchAssets();
    }, [fetchAssets]);

    const handleAssetCardClick = (asset) => {
        setSelectedAsset(asset);
    };

    const handleCloseModal = () => {
        setSelectedAsset(null);
    };

    /*
     
    */ 
   
    return (
        <main className="tyk-page">
            <div className="tyk-page-shell">
            <section className="tyk-hero-panel">
                <div>
                    <span className="tyk-kicker">Property marketplace</span>
                    <h1 className="tyk-hero-title">Real Estate</h1>
                    <p className="tyk-hero-copy">
                        Browse land, homes, and shared property opportunities with clean details before opening a listing.
                    </p>
                </div>
            </section>
           
            <section className="tyk-panel">
            <RealEstateList
                assets={assets}
                loading={loading}
                error={error}
                onRetry={fetchAssets}
                onAssetCardClick={handleAssetCardClick}
            />

            {selectedAsset && (
                <Modal show={!!selectedAsset} onHide={handleCloseModal} className="tyk-modal" centered size="lg">
                    <Modal.Header closeButton closeVariant="white">
                        <div>
                            <span className="tyk-kicker">Listing detail</span>
                            <Modal.Title>{selectedAsset.assetName}</Modal.Title>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="tyk-panel">
                            {selectedAsset.imageURL && (
                                <img
                                    src={selectedAsset.imageURL}
                                    alt={selectedAsset.assetName}
                                    className="mb-4 h-72 w-full rounded-xl object-cover"
                                />
                            )}
                            <p className="text-slate-200">{selectedAsset.assetDescription || 'No description has been added yet.'}</p>
                            <div className="tyk-stat-row mt-3">
                                <div className="tyk-stat">
                                    <span>Location</span>
                                    <strong className="text-base">{selectedAsset.location || 'Not listed'}</strong>
                                </div>
                                <div className="tyk-stat">
                                    <span>Availability</span>
                                    <strong className="text-base">{selectedAsset.availability === false ? 'Unavailable' : 'Available'}</strong>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
            </section>
            </div>
        </main>
    );
};

export default RealEstatePage;

